import { ColDef } from 'ag-grid-community';
import {
    RECURRENCE,
    POSITION_ADMIN,
    POSITION_STATUTAIRE,
    QUALITE_EMPLOI,
    INDICIAIRE,
    MANTY_STATUS,
    RETIREMENT_SYSTEM,
    SOFTWARE_RETIREMENT_SYSTEM,
} from 'routes/HumanResourcesModule/business/definitions';
import {
    floatingFilter,
    hrPositionMappingValueGetter,
    recurrentFormatter,
} from './gridHelpers';
import {
    IndiciaireEnum,
    MantyStatus,
    RecurrenceEnum,
    RetirementSystem,
} from './constants';

const baseColDef = {
    ...floatingFilter,
    sortable: true,
    resizable: true,
    enableRowGroup: true,
};

export const getColDefs = (
    t: TranslationT,
    useAlternativeFieldList: boolean = true,
): ColDef[] => {
    const defaultColumns = [
        {
            headerName: '',
            width: 50,
            minWidth: 50,
            maxWidth: 50,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            suppressHeaderMenuButton: true,
            suppressSizeToFit: true,
        },
    ];

    const destinationFields = useAlternativeFieldList
        ? [POSITION_ADMIN, POSITION_STATUTAIRE, QUALITE_EMPLOI]
        : [POSITION_STATUTAIRE, SOFTWARE_RETIREMENT_SYSTEM];

    const destinationFieldColumns = destinationFields.map((field) => ({
        headerName: t(`humanResources.settings.${field}`),
        field,
        cellRenderer: 'tooltipCellRenderer',
        ...baseColDef,
    }));
    const mappingToggleFieldColumns = [
        {
            headerName: t('humanResources.settings.recurrence'),
            headerTooltip: t('humanResources.settings.recurrenceTooltip'),
            field: RECURRENCE,
            filterValueGetter: recurrentFormatter,
            cellRenderer: 'hrMappingToggleCellRenderer',
            cellRendererParams: {
                fieldToUpdate: RECURRENCE,
                valueChecked: RecurrenceEnum.RECURRENT,
                valueUnchecked: RecurrenceEnum.NON_RECURRENT,
            },
            ...baseColDef,
        },
        {
            headerName: t('humanResources.settings.indiciaire'),
            headerTooltip: t('humanResources.settings.indiciaireTooltip'),
            field: INDICIAIRE,
            filterValueGetter: hrPositionMappingValueGetter(INDICIAIRE),
            cellRenderer: 'hrMappingToggleCellRenderer',
            cellRendererParams: {
                fieldToUpdate: INDICIAIRE,
                valueChecked: IndiciaireEnum.INDICIAIRE,
                valueUnchecked: IndiciaireEnum.NON_INDICIAIRE,
            },
            ...baseColDef,
        },
        {
            headerName: t('humanResources.settings.mantyStatus'),
            field: MANTY_STATUS,
            filterValueGetter: hrPositionMappingValueGetter(MANTY_STATUS),
            cellRenderer: 'hrMappingSelectorCellRenderer',
            cellRendererParams: {
                fieldToUpdate: MANTY_STATUS,
                fieldEnum: MantyStatus,
            },
            ...baseColDef,
        },
        {
            headerName: t('humanResources.settings.retirementSystem'),
            field: RETIREMENT_SYSTEM,
            filterValueGetter: hrPositionMappingValueGetter(RETIREMENT_SYSTEM),
            cellRenderer: 'hrMappingSelectorCellRenderer',
            cellRendererParams: {
                fieldToUpdate: RETIREMENT_SYSTEM,
                fieldEnum: RetirementSystem,
            },
            ...baseColDef,
        },
    ];

    return [
        ...defaultColumns,
        ...destinationFieldColumns,
        ...mappingToggleFieldColumns,
    ];
};
